import { NAME } from './constants';
import type { AssetsState } from './reducer';
import type { AssetsSlice } from './types';

export const getState = (state: AssetsSlice): AssetsState => state[NAME];
